import axios from "axios";
import {
  onGlobalSuccess,
  onGlobalError,
  API_HOST_PREFIX,
} from "./serviceHelpers";

const loginEndpoint = `${API_HOST_PREFIX}/api/login`;

const userLogin = (payload) => {
  const config = {
    method: "POST",
    url: `${loginEndpoint}/login`,
    data: payload,
    withCredentials: true,
    crossdomain: true,
  };

  return axios(config).then(onGlobalSuccess).catch(onGlobalError);
};

const getCurrentUser = () => {
  const config = {
    method: "GET",
    url: `${loginEndpoint}/me`,
    withCredentials: true,
    crossdomain: true,
  };

  return axios(config).then(onGlobalSuccess).catch(onGlobalError);
};

const changePassword = (payload) => {
  const config = {
    method: "POST",
    url: `${loginEndpoint}/change-password`,
    data: payload,
    withCredentials: true,
    crossdomain: true,
  };

  return axios(config).then(onGlobalSuccess).catch(onGlobalError);
};

const userLogout = () => {
  const config = {
    method: "GET",
    url: `${loginEndpoint}/logout`,
    withCredentials: true,
    crossdomain: true,
  };

  return axios(config).then(onGlobalSuccess).catch(onGlobalError);
};

const loginService = {
  userLogin,
  getCurrentUser,
  userLogout,
  changePassword,
};

export default loginService;
